(function () {
  'use strict';

  const LS_NAME_KEY = 'parentPayName';
  const SHARE_API_BASE = 'https://share.evryjewels.com';

  const PILLS = [
    '🥹 pretty please 💗',
    '🎁 for my birthday ✨',
    '🙏 this would mean everything to me',
  ];

  // ── Analytics ─────────────────────────────────────────────────────────────────
  // GTM dataLayer push. Guarded so it self-initializes if GTM is blocked or
  // hasn't loaded yet when the cart drawer is used.
  function pushDL(event, data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: event }, data || {}));
  }

  // ── Fonts ─────────────────────────────────────────────────────────────────────
  function ensureFonts() {
    if (document.getElementById('pp-britt-face')) return;
    const style = document.createElement('style');
    style.id = 'pp-britt-face';
    style.textContent = '@font-face{font-family:"font-britt";src:url("//evryjewels.com/cdn/shop/files/font-britt.woff2?v=6254689858542886435") format("woff2");font-display:swap;font-weight:500;}';
    document.head.appendChild(style);
  }

  // ── Toast ─────────────────────────────────────────────────────────────────────
  function showToast(msg) {
    const existing = document.querySelector('.parent-pay-toast');
    if (existing) existing.remove();
    const toast = document.createElement('div');
    toast.className = 'parent-pay-toast';
    toast.textContent = msg;
    toast.style.cssText = `
      position:fixed;bottom:24px;left:50%;transform:translateX(-50%);
      background:#1A1216;color:#fff;padding:14px 22px;border-radius:999px;
      font-family:system-ui,-apple-system,"Segoe UI",Roboto,sans-serif;font-size:14px;font-weight:600;
      z-index:1100011;max-width:90vw;box-shadow:0 8px 32px rgba(0,0,0,.2);
      animation:ppToastIn .3s ease;
    `;
    document.body.appendChild(toast);
    setTimeout(() => {
      toast.style.transition = 'opacity .3s ease';
      toast.style.opacity = '0';
      setTimeout(() => toast.remove(), 300);
    }, 2700);
  }

  // ── Cart fetch ────────────────────────────────────────────────────────────────
  // Legacy compact string (fallback when the stash worker is unreachable)
  function cartToLegacyParam(cart) {
    return cart.items.map((i) => `${i.handle}:${i.variant_id}:${i.quantity}`).join(',');
  }

  function readMarkdownMap() {
    const el = document.getElementById('pp-fd-markdowns');
    if (!el) return {};
    try {
      const arr = JSON.parse(el.textContent);
      if (!Array.isArray(arr)) return {};
      const map = {};
      arr.forEach(function (entry) { if (entry && entry.id != null && entry.data) map[entry.id] = entry.data; });
      return map;
    } catch (e) {
      return {};
    }
  }

  // Full snapshot for the stash worker
  async function getCartPayload() {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    if (!cart.items || cart.items.length === 0) return null;
    const mdMap = readMarkdownMap();
    return {
      items: cart.items.map((i) => {
        const md = mdMap[i.variant_id];
        return {
          id: i.variant_id,
          handle: i.handle,
          quantity: i.quantity,
          title: i.product_title || i.title,
          variant_title: i.variant_title || '',
          image: i.image || (i.featured_image && i.featured_image.url) || '',
          price: i.price,
          line_price: i.final_line_price,
          properties: i.properties && Object.keys(i.properties).length ? i.properties : null,
          selling_plan: (i.selling_plan_allocation && i.selling_plan_allocation.selling_plan && i.selling_plan_allocation.selling_plan.id) || null,
          markdown: (md && (md.applied || md.compare != null)) ? md : undefined,
        };
      }),
      subtotal: cart.items_subtotal_price,
      total: cart.total_price,
      currency: cart.currency,
      legacyParam: cartToLegacyParam(cart),
    };
  }

  // ── Stash helpers ─────────────────────────────────────────────────────────────
  async function createStash(payload) {
    try {
      const res = await fetch(`${SHARE_API_BASE}/stash`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: payload.items,
          subtotal: payload.subtotal,
          total: payload.total,
          currency: payload.currency,
        }),
      });
      if (!res.ok) return null;
      return await res.json(); // { slug, url }
    } catch (e) {
      console.warn('[parent-pay] stash create failed (will fall back to long link)', e);
      return null;
    }
  }

  function updateStash(slug, name, note) {
    // Fire-and-forget; keepalive lets it survive the share-sheet handoff.
    try {
      fetch(`${SHARE_API_BASE}/stash/${encodeURIComponent(slug)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ from: name, note: note }),
        keepalive: true,
      }).catch(function () {});
    } catch (e) { /* non-fatal */ }
  }

  // ── Share ─────────────────────────────────────────────────────────────────────
  async function triggerShare(shareUrl, name) {
    const shareText = name
      ? `hey! it's ${name}! i found some pieces i'm obsessed with at evry jewels 💗 would you be able to get them for me? here's the cart →`
      : `hey! i found some pieces i'm obsessed with at evry jewels 💗 would you be able to get them for me? here's the cart →`;

    if (navigator.share) {
      await navigator.share({
        title: 'Evry Jewels — a little wishlist',
        text: shareText,
        url: shareUrl,
      });
    } else {
      await navigator.clipboard.writeText(`${shareText} ${shareUrl}`);
      showToast('Link copied! Paste it in a text 💗');
    }
  }

  function buildLegacyUrl(payload, name, note) {
    const url = new URL(window.location.origin + '/pages/for-you');
    url.searchParams.set('cart', payload.legacyParam);
    if (name) url.searchParams.set('from', name);
    if (note) url.searchParams.set('note', note);
    if (payload.subtotal != null) url.searchParams.set('subtotal', payload.subtotal);
    if (payload.total != null) url.searchParams.set('total', payload.total);
    return url.toString();
  }

  // ── Modal styles ──────────────────────────────────────────────────────────────
  const MODAL_CSS = `
    @keyframes ppFadeIn {
      from { opacity: 0; }
      to   { opacity: 1; }
    }
    @keyframes ppSlideUp {
      from { opacity: 0; transform: translateY(20px) scale(0.96); }
      to   { opacity: 1; transform: translateY(0)    scale(1);    }
    }
    @keyframes ppToastIn {
      from { opacity: 0; transform: translateX(-50%) translateY(8px); }
      to   { opacity: 1; transform: translateX(-50%) translateY(0);   }
    }

    .pp-overlay {
      position: fixed; inset: 0; z-index: 1100010;
      display: flex; align-items: center; justify-content: center; padding: 20px;
      background: rgba(255, 111, 165, 0.18);
      backdrop-filter: blur(4px); -webkit-backdrop-filter: blur(4px);
      animation: ppFadeIn 200ms ease forwards;
    }
    .pp-overlay.pp-closing {
      animation: ppFadeIn 200ms ease reverse forwards;
    }

    .pp-modal {
      position: relative; width: 100%; max-width: 420px;
      background: #fff; border-radius: 24px; padding: 28px;
      box-shadow: 0 24px 80px rgba(26,18,22,.18);
      animation: ppSlideUp 300ms cubic-bezier(0.16,1,0.3,1) forwards;
    }
    .pp-overlay.pp-closing .pp-modal {
      animation: ppSlideUp 200ms cubic-bezier(0.16,1,0.3,1) reverse forwards;
    }

    .pp-close {
      position: absolute; top: 16px; right: 16px;
      width: 32px; height: 32px; border: none; background: #F8F1F4;
      border-radius: 50%; cursor: pointer; font-size: 16px; color: #4B3741;
      display: flex; align-items: center; justify-content: center;
      transition: background .2s;
    }
    .pp-close:hover { background: #F2E1E7; }

    .pp-headline {
      font-family: "font-britt", sans-serif;
      font-size: 24px; font-weight: 400; color: #1A1216;
      margin: 0 0 8px; line-height: 1.3;
    }
    .pp-subtext {
      font-family: system-ui, -apple-system, "Segoe UI", Roboto, sans-serif;
      font-size: 14px; color: #4B3741; margin: 0 0 24px; line-height: 1.5;
    }

    .pp-label {
      display: block; font-family: system-ui, -apple-system, "Segoe UI", Roboto, sans-serif;
      font-size: 11px; font-weight: 700; letter-spacing: .14em;
      text-transform: uppercase; color: #8A7A82; margin-bottom: 8px;
    }

    .pp-input, .pp-textarea {
      width: 100%; box-sizing: border-box; padding: 14px 16px;
      border: 1.5px solid #F2E1E7; border-radius: 12px;
      font-family: system-ui, -apple-system, "Segoe UI", Roboto, sans-serif; font-size: 16px; color: #1A1216;
      background: #fff; outline: none;
      transition: border-color .2s, box-shadow .2s;
    }
    .pp-input { margin-bottom: 20px; }
    .pp-textarea { resize: none; }
    .pp-input:focus, .pp-textarea:focus {
      border-color: #E84D88;
      box-shadow: 0 0 0 4px rgba(232,77,136,.12);
    }

    .pp-pills {
      display: flex; gap: 8px; overflow-x: auto;
      padding-bottom: 4px; margin-bottom: 10px; scrollbar-width: none;
    }
    .pp-pills::-webkit-scrollbar { display: none; }

    .pp-pill {
      padding: 8px 14px; border: 1px solid #F2E1E7; border-radius: 999px;
      background: #FFF9FA; font-family: system-ui, -apple-system, "Segoe UI", Roboto, sans-serif;
      font-size: 13px; font-weight: 600; color: #4B3741;
      cursor: pointer; white-space: nowrap; flex-shrink: 0;
      transition: all .2s ease;
    }
    .pp-pill:hover { background: #FFEAF0; border-color: #FF6FA5; }
    .pp-pill.pp-pill--active {
      background: #FFEAF0; border-color: #E84D88; color: #E84D88;
    }

    .pp-char-count {
      font-family: system-ui, -apple-system, "Segoe UI", Roboto, sans-serif; font-size: 11px; color: #8A7A82;
      text-align: right; margin-top: 4px; margin-bottom: 20px;
    }

    .pp-submit {
      display: flex; align-items: center; justify-content: center; gap: 8px;
      width: 100%; padding: 16px 20px;
      background: #E84D88; color: #fff; border: none; border-radius: 10px;
      font-family: system-ui, -apple-system, "Segoe UI", Roboto, sans-serif; font-size: 16px; font-weight: 700;
      cursor: pointer; transition: all .3s ease; margin-bottom: 12px;
    }
    .pp-submit:hover {
      background: #D63A77; transform: translateY(-1px);
      box-shadow: 0 4px 16px rgba(232,77,136,.3);
    }
    .pp-submit:active { transform: translateY(0); }

    .pp-skip {
      display: block; text-align: center; width: 100%;
      font-family: system-ui, -apple-system, "Segoe UI", Roboto, sans-serif; font-size: 13px; color: #8A7A82;
      background: none; border: none; cursor: pointer; padding: 4px;
      transition: color .2s;
    }
    .pp-skip:hover { color: #4B3741; }
  `;

  function injectStyles() {
    if (document.getElementById('pp-modal-styles')) return;
    const style = document.createElement('style');
    style.id = 'pp-modal-styles';
    style.textContent = MODAL_CSS;
    document.head.appendChild(style);
  }

  // ── Modal HTML ────────────────────────────────────────────────────────────────
  function buildModal() {
    const div = document.createElement('div');
    div.innerHTML = `
      <div class="pp-overlay" id="ppOverlay" role="dialog" aria-modal="true" aria-labelledby="ppHeadline">
        <div class="pp-modal" id="ppModal">
          <button class="pp-close" id="ppClose" aria-label="Close">&#x2715;</button>
          <h2 class="pp-headline" id="ppHeadline">tell them it&rsquo;s <em>from you</em> &#x2728;</h2>
          <p class="pp-subtext">We&rsquo;ll add this to the message so they know it&rsquo;s you &#x1F497;</p>

          <label class="pp-label" for="ppName">YOUR NAME</label>
          <input class="pp-input" id="ppName" type="text"
            placeholder="What should we call you?" autocomplete="given-name" maxlength="60" />

          <label class="pp-label">A LITTLE NOTE (OPTIONAL)</label>
          <div class="pp-pills" id="ppPills">
            ${PILLS.map((p, i) => `<button class="pp-pill" type="button" data-pill-index="${i}">${p}</button>`).join('')}
          </div>
          <textarea class="pp-textarea" id="ppNote" rows="3"
            placeholder="or write your own message..." maxlength="200"></textarea>
          <div class="pp-char-count" id="ppCharCount">0 / 200</div>

          <button class="pp-submit" id="ppSubmit" type="button">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
            </svg>
            Share now
          </button>
          <button class="pp-skip" id="ppSkip" type="button">skip and share anyway &#x2192;</button>
        </div>
      </div>
    `;
    return div.firstElementChild;
  }

  // ── Modal lifecycle ───────────────────────────────────────────────────────────
  let modalOpen = false;
  let previouslyFocused = null;
  let pendingPayload = null;
  let pendingShortUrl = null;

  function openModal(payload) {
    if (modalOpen) return;
    modalOpen = true;
    pendingPayload = payload;
    pendingShortUrl = null;
    previouslyFocused = document.activeElement;

    // Kick off the stash now so the short URL is ready before "Share now".
    createStash(payload).then(function (result) {
      if (result && result.url) pendingShortUrl = result.url;
    });

    ensureFonts();
    injectStyles();

    const overlay = buildModal();
    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';

    // Neutralise the cart drawer's Bootstrap focus trap so our inputs are reachable.
    // `inert` removes the element from tab order and blocks focusin capture entirely.
    const offcanvas = document.querySelector('.offcanvas.show, .offcanvas.showing');
    if (offcanvas) offcanvas.setAttribute('inert', '');

    const nameInput = overlay.querySelector('#ppName');
    const noteArea  = overlay.querySelector('#ppNote');
    const charCount = overlay.querySelector('#ppCharCount');
    const pillBtns  = overlay.querySelectorAll('.pp-pill');

    // Pre-fill name
    const savedName = localStorage.getItem(LS_NAME_KEY) || '';
    nameInput.value = savedName;

    // Focus: note field if name pre-filled, otherwise name field
    setTimeout(() => (savedName ? noteArea : nameInput).focus(), 50);

    // Character counter + pill sync
    noteArea.addEventListener('input', () => {
      charCount.textContent = `${noteArea.value.length} / 200`;
      pillBtns.forEach((btn, i) => {
        btn.classList.toggle('pp-pill--active', noteArea.value === PILLS[i]);
      });
    });

    // Pills
    pillBtns.forEach((btn, i) => {
      btn.addEventListener('click', () => {
        noteArea.value = PILLS[i];
        noteArea.dispatchEvent(new Event('input'));
        noteArea.focus();
      });
    });

    // Close triggers
    overlay.querySelector('#ppClose').addEventListener('click', closeModal);
    overlay.addEventListener('click', (e) => { if (e.target === overlay) closeModal(); });
    overlay.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') { closeModal(); return; }
      if (e.key === 'Tab') trapFocus(e, overlay);
    });

    // Actions
    overlay.querySelector('#ppSubmit').addEventListener('click', () => doShare(false));
    overlay.querySelector('#ppSkip').addEventListener('click', () => doShare(true));
  }

  function closeModal() {
    const overlay = document.getElementById('ppOverlay');
    if (!overlay) return;
    overlay.classList.add('pp-closing');
    setTimeout(() => {
      overlay.remove();
      // Restore cart drawer interactivity now that our modal is fully gone.
      const inertedOffcanvas = document.querySelector('.offcanvas[inert]');
      if (inertedOffcanvas) inertedOffcanvas.removeAttribute('inert');
      modalOpen = false;
      pendingPayload = null;
      pendingShortUrl = null;
      document.body.style.overflow = '';
      if (previouslyFocused) previouslyFocused.focus();
    }, 200);
  }

  function trapFocus(e, overlay) {
    const focusable = overlay.querySelectorAll(
      'button:not([disabled]), input, textarea, [tabindex]:not([tabindex="-1"])'
    );
    const first = focusable[0];
    const last  = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  }

  // ── Share action ──────────────────────────────────────────────────────────────
  async function doShare(skip) {
    const payload   = pendingPayload;   // capture before closeModal nulls it
    const shortUrl  = pendingShortUrl;

    let name = '';
    let note = '';
    if (!skip) {
      const nameEl = document.getElementById('ppName');
      const noteEl = document.getElementById('ppNote');
      name = nameEl ? nameEl.value.trim() : '';
      note = noteEl ? noteEl.value.trim() : '';
      if (name) localStorage.setItem(LS_NAME_KEY, name);
    }

    closeModal();

    if (!payload) return;

    try {
      if (shortUrl) {
        const slug = shortUrl.split('/p/')[1];
        if (slug) updateStash(slug, name, note);
        await triggerShare(shortUrl, name);
      } else {
        await triggerShare(buildLegacyUrl(payload, name, note), name);
      }
      // Only reached when the share genuinely completed — a cancelled native
      // share rejects with AbortError and skips this.
      pushDL('parent_pay_share_complete', {
        share_source: 'offcanvas_cart',
        value: (payload.total || 0) / 100,   // major currency units (cart total is in cents)
        currency: payload.currency,
        item_count: payload.items.reduce((n, i) => n + i.quantity, 0),
        share_method: navigator.share ? 'native_share' : 'clipboard',
        used_note: !skip && note.length > 0,
      });
    } catch (err) {
      if (err.name === 'AbortError') return;
      console.error('Parent-pay share error:', err);
      showToast('Something went wrong. Try again?');
    }
  }

  // ── Entry point ───────────────────────────────────────────────────────────────
  async function handleShare() {
    // Fire synchronously before the async cart fetch so every real click is
    // captured (including empty-cart clicks that only show a toast).
    pushDL('parent_pay_share_click', { share_source: 'offcanvas_cart' });
    try {
      const payload = await getCartPayload();
      if (!payload) {
        showToast("Your bag is empty bestie! Add something first 💗");
        return;
      }
      openModal(payload);
    } catch (err) {
      console.error('Parent-pay share error:', err);
      showToast('Something went wrong. Try again?');
    }
  }

  // Event delegation — works even after cart drawer re-renders
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-parent-pay-share]');
    if (btn) { e.preventDefault(); handleShare(); }
  });
})();
